import * as VueGoogleMaps from 'gmap-vue'

interface GmapOverlayViewType {
  bounds_: google.maps.LatLngBounds
  image_: string
  map_: google.maps.Map
  isShown_: boolean
  div_: HTMLDivElement | null
  setMap: any
  getPanes: any
  getProjection: any
  show: any
  hide: any
  getMap: any
}

function CreateOverlayView () {
  GmapOverlayView.prototype = new google.maps.OverlayView()
  function GmapOverlayView (bounds:any, image:string, map: any, isShown: boolean) {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    // Initialize all properties.
    self.bounds_ = bounds
    self.image_ = image
    self.map_ = map
    self.isShown_ = isShown

    // Define a property to hold the image's div. We'll
    // actually create this div upon receipt of the onAdd()
    // method so we'll leave it null for now.
    self.div_ = null

    // Explicitly call setMap on this overlay.
    self.setMap(map)
  }

  GmapOverlayView.prototype.onAdd = function onAdd (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    const div: HTMLDivElement = document.createElement('div')
    div.id = self.image_
    div.style.borderStyle = 'none'
    div.style.borderWidth = '0px'
    div.style.position = 'absolute'

    // Create the img element and attach it to the div.
    const img = document.createElement('img')
    img.src = self.image_
    img.style.width = '100%'
    img.style.height = '100%'
    div.appendChild(img)

    self.div_ = div

    // Add the element to the "overlayLayer" pane.
    const panes = self.getPanes()
    panes.overlayLayer.appendChild(div)
  }

  GmapOverlayView.prototype.draw = function draw (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    // We use the south-west and north-east
    // coordinates of the overlay to peg it to the correct position and size.
    // To do this, we need to retrieve the projection from the overlay.
    const overlayProjection = self.getProjection()

    // Retrieve the south-west and north-east coordinates of this overlay
    // in LatLngs and convert them to pixel coordinates.
    // We'll use these coordinates to resize the div.
    const sw = overlayProjection.fromLatLngToDivPixel(self.bounds_.getSouthWest())
    const ne = overlayProjection.fromLatLngToDivPixel(self.bounds_.getNorthEast())

    if (self.div_) {
      // Resize the image's div to fit the indicated dimensions.
      const div: HTMLDivElement = self.div_
      div.style.left = sw.x + 'px'
      div.style.top = ne.y + 'px'
      div.style.width = (ne.x - sw.x) + 'px'
      div.style.height = (sw.y - ne.y) + 'px'
      div.style.visibility = self.isShown_ ? 'visible' : 'hidden'
    } else {
      throw new Error('GmapOverlayView: the div element has not been initialised')
    }
  }

  GmapOverlayView.prototype.onRemove = function onRemove (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this

    if (self.div_ && self.div_.parentNode) {
      self.div_.parentNode.removeChild(self.div_)
      self.div_ = null
    }
  }

  // @ts-ignore
  GmapOverlayView.prototype.hide = function hide (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    if (self.div_) {
      // The visibility property must be a string enclosed in quotes.
      self.div_.style.visibility = 'hidden'
    }
  }

  // @ts-ignore
  GmapOverlayView.prototype.show = function show (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    if (self.div_) {
      self.div_.style.visibility = 'visible'
    }
  }

  // @ts-ignore
  GmapOverlayView.prototype.toggle = function toggle (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    if (self.div_) {
      if (self.div_.style.visibility === 'visible') {
        self.show()
      } else {
        self.hide()
      }
    }
  }
  // @ts-ignore
  GmapOverlayView.prototype.toggleDOM = function toggleDOM (): void {
    // @ts-ignore
    const self: GmapOverlayViewType = this
    if (self.getMap()) {
      // Note: setMap(null) calls OverlayView.onRemove()
      self.setMap(null)
    } else {
      self.setMap(self.map_)
    }
  }

  return GmapOverlayView
}

const props = {
  bounds: {
    type: Object
  },
  image: {
    type: String
  },
  map: {
    type: Object
  },
  isShown: {
    type: Boolean,
    default: true
  }
}
const events: string [] = ['click', 'dblclick']

export default VueGoogleMaps.MapElementFactory({
  mappedProps: {},
  events,
  name: 'GmapOverlayView',
  ctr: () => {
    // @ts-ignore
    return CreateOverlayView()
  },
  ctrArgs: (
    { map }: {map:google.maps.Map},
    { bounds, image, isShown }: {bounds:google.maps.LatLngBounds, image:string, isShown: boolean}
  ) => {
    return [bounds, image, map, isShown]
  },
  props,
  methods: {

  },
  afterCreate: function () {
    if (!this.isShown) {
      this.$GmapOverlayViewObject.hide()
    }
  },
  destroyed: function () {
    this.$GmapOverlayViewObject.toggleDOM()
  },
  watch: {
    isShown: function (val: boolean) {
      // @ts-ignore
      this.$GmapOverlayViewObject.isShown_ = val
      if (val) {
        // @ts-ignore
        this.$GmapOverlayViewObject.show()
      } else {
        // @ts-ignore
        this.$GmapOverlayViewObject.hide()
      }
    }
  }
})
